import { commonRequest, request } from '@/utils/request'
import { agentRequest } from './common/agentRequest'
export interface ISessionProps {
  session_id: string | null
  answer_id?: string
  content?: string
}
// 获取知识库列表
export const getKnList = (payload: any) => {
  return commonRequest.post('/kn/get_list', {
    ...payload,
  })
}

// 获取助手类型
export const getAssistantType = () => {
  return agentRequest.get('/type')
}
// 获取精选推荐
export const getFeatureList = () => {
  return request.get('/agents/feature_list')
}
// 获取官方推荐列表
export const getOfficialRecommendList = () => {
  return request.get('/agents/list')
}
// 聚合搜索列表
export const getSearchAssistantList = (payload: any) => {
  return request.get('/agents/search', {
    params: {
      ...payload,
    },
  })
}
// 标记Agent已点击
export const agentOperate = (payload: any) => {
  return request.post(
    `/agents/operate?id=${payload.id}&action=${payload.mark_as_clicked}`,
    {},
  )
}
// 获取助手列表
export const getAssistantList = (payload: any) => {
  return agentRequest.get('/list', {
    params: {
      ...payload,
    },
  })
}

// 助手收藏、取消收藏  cancel  = 1 表示取消
export const updateCollect = (payload: any) => {
  return agentRequest.post('/like', {
    ...payload,
  })
}

// 获取助手详情
export const getAssistantDetail = (payload: any) => {
  return agentRequest.get('/detail', {
    params: {
      ...payload,
    },
  })
}

// 创建助手
export const createAssistant = (payload: any) => {
  return agentRequest.post('/create', {
    ...payload,
  })
}

// 更新助手
export const updateAssistant = (payload: any) => {
  return agentRequest.post('/update', {
    ...payload,
  })
}

// 删除助手
export const deleteAssistant = (payload: any) => {
  return agentRequest.post('/delete', {
    ...payload,
  })
}

// 助手对话历史列表
export const getRecordList = () => {
  return agentRequest.get('/history')
}
// 助手对话历史列表
export const getAppChatRecord = (app_id: string) => {
  return agentRequest.get(`/history/${app_id}`)
}

// 删除助手对话记录
export const ClearRecord = (params: any) => {
  return agentRequest.get('/chat/clearHistories', {
    params,
    baseURL: '/ai-agent/api/core',
  })
}

// 单个助手聊天记录
export const getSessionsHistory = (payload: any) => {
  return agentRequest.post('/chat_history', { ...payload })
}

// 获取默认头像列表
export const getDefaultImages = () => {
  return agentRequest.get('/default_images')
}

// 一键生成智能体
export const oneTouchAgent = (payload: any) => {
  return agentRequest.post(
    '/gen',
    {
      ...payload,
    },
    {
      timeout: 60000,
    },
  )
}

// ai生成头像
export const text2img = (payload: any) => {
  return agentRequest.post(
    '/core/ai/text2img',
    {
      ...payload,
    },
    {
      baseURL: '/ai-agent/api',
    },
  )
}

// 获取话题追问
export const questionGuide = (payload: any) => {
  return agentRequest.post(
    '/core/ai/questionGuide',
    {
      ...payload,
    },
    {
      baseURL: '/ai-agent/api',
    },
  )
}

// 自定义头像上传函数
export const uploadImg = (payload: any) => {
  return commonRequest.post('/storage/upload/simple', payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

/**
 * 详情
 */
export const createLink = (payload: any) => {
  return agentRequest.post(
    '/support/outLink/create',
    {
      ...payload,
    },
    {
      baseURL: '/ai-agent/api',
    },
  )
}

export const deleteLink = (id: any) => {
  return agentRequest.post(`/support/outLink/delete?id=${id}`, {
    baseURL: '/ai-agent/api',
  })
}

export const updateLink = (payload: any) => {
  return agentRequest.post(
    '/support/outLink/update',
    {
      ...payload,
    },
    {
      baseURL: '/ai-agent/api',
    },
  )
}

export const getLinkList = (payload: any) => {
  return agentRequest.post(
    '/support/outLink/external/list',
    {
      ...payload,
    },
    {
      baseURL: '/ai-agent/api',
    },
  )
}

export const findAppDetail = (appId: any) => {
  return agentRequest.get('/core/app/external/detail', {
    params: {
      appId,
    },
    baseURL: '/ai-agent/api',
  })
}

export const getChatLogs = (payload: any) => {
  return agentRequest.post(
    '/core/app/getChatLogs',
    {
      ...payload,
    },
    {
      baseURL: '/ai-agent/api',
    },
  )
}

// 导出历史记录
export const exportChatHistory = (params: any) => {
  return agentRequest.get('/core/chat/exportChatHistory', {
    params,
    baseURL: '/ai-agent/api',
  })
}

// 对话日志详情
export const chatLogsDetail = (params: any) => {
  return agentRequest.get('/core/chat/init', {
    params,
    baseURL: '/ai-agent/api',
  })
}
